import { EquipmentProvider } from 'Context';
import { EquipmentMain } from './EquipmentMain';

export const Equipment = () => {
  return (
    <EquipmentProvider>
      <EquipmentMain />
    </EquipmentProvider>
  );
};
